import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PoolButton, PoolTypography } from '@synergy/components';
import { PureComponent } from 'react';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
        },
        navLink: {
            marginTop: theme.spacing(3),
            textDecoration: 'none',
            '& button': {
                height: '100%',
            },
        },
    });

export const NotFound = withStyles(styles)(
    class NotFoundBase extends PureComponent<WithStyles<typeof styles>> {
        public override render() {
            const { classes } = this.props;

            return (
                <div className={classes.container}>
                    <PoolTypography typography="h6" id="app.inquiries.notFound" />
                    <Link to="/dashboard" className={classes.navLink}>
                        <PoolButton styleType="firstLevel">
                            <FormattedMessage id="app.header.overview" />
                        </PoolButton>
                    </Link>
                </div>
            );
        }
    }
);
